import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Card, Button, ListGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';

function AdminDashboardScreen() {
    const navigate = useNavigate();

    const userLogin = useSelector(state => state.userLogin);
    const { userInfo } = userLogin;

    useEffect(() => {
        if (!userInfo || !userInfo.isAdmin) {
            navigate('/login');
        }
    }, [navigate, userInfo]);

    return (
        <div>
            <h1 className="mb-4">Admin Dashboard</h1>
            
            <Row className="mb-4">
                <Col md={3}>
                    <Card className="text-center">
                        <Card.Body>
                            <Card.Title>Products</Card.Title>
                            <h2 className="text-primary">-</h2>
                            <LinkContainer to="/admin/products">
                                <Button variant="outline-primary" size="sm">
                                    Manage Products
                                </Button>
                            </LinkContainer>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="text-center">
                        <Card.Body>
                            <Card.Title>Orders</Card.Title>
                            <h2 className="text-success">-</h2>
                            <LinkContainer to="/admin/orders">
                                <Button variant="outline-success" size="sm">
                                    Manage Orders
                                </Button>
                            </LinkContainer>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="text-center">
                        <Card.Body>
                            <Card.Title>Users</Card.Title>
                            <h2 className="text-info">-</h2>
                            <LinkContainer to="/admin/users">
                                <Button variant="outline-info" size="sm">
                                    Manage Users
                                </Button>
                            </LinkContainer>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="text-center">
                        <Card.Body>
                            <Card.Title>AI Book Jobs</Card.Title>
                            <h2 className="text-warning">-</h2>
                            <LinkContainer to="/admin/genai/jobs">
                                <Button variant="outline-warning" size="sm">
                                    View Jobs
                                </Button>
                            </LinkContainer>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="text-center">
                        <Card.Body>
                            <Card.Title>GenAI Metrics</Card.Title>
                            <h2 className="text-secondary">→</h2>
                            <LinkContainer to="/admin/metrics">
                                <Button variant="outline-secondary" size="sm">
                                    View Report
                                </Button>
                            </LinkContainer>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <h3>Quick Actions</h3>
                    <Card>
                        <ListGroup variant="flush">
                            <ListGroup.Item className="d-flex justify-content-between align-items-center">
                                <span><i className="fas fa-box me-2"></i>Product Management</span>
                                <LinkContainer to="/admin/products">
                                    <Button variant="primary" size="sm">Go to Products</Button>
                                </LinkContainer>
                            </ListGroup.Item>
                            <ListGroup.Item className="d-flex justify-content-between align-items-center">
                                <span><i className="fas fa-shopping-cart me-2"></i>Order Management</span>
                                <LinkContainer to="/admin/orders">
                                    <Button variant="success" size="sm">Go to Orders</Button>
                                </LinkContainer>
                            </ListGroup.Item>
                            <ListGroup.Item className="d-flex justify-content-between align-items-center">
                                <span><i className="fas fa-users me-2"></i>User Management</span>
                                <LinkContainer to="/admin/users">
                                    <Button variant="info" size="sm">Go to Users</Button>
                                </LinkContainer>
                            </ListGroup.Item>
                            <ListGroup.Item className="d-flex justify-content-between align-items-center">
                                <span><i className="fas fa-book me-2"></i>AI Book Jobs</span>
                                <LinkContainer to="/admin/genai/jobs">
                                    <Button variant="warning" size="sm">View Jobs</Button>
                                </LinkContainer>
                            </ListGroup.Item>
                            <ListGroup.Item className="d-flex justify-content-between align-items-center">
                                <span><i className="fas fa-chart-bar me-2"></i>GenAI Metrics</span>
                                <LinkContainer to="/admin/metrics">
                                    <Button variant="secondary" size="sm">View Report</Button>
                                </LinkContainer>
                            </ListGroup.Item>
                        </ListGroup>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default AdminDashboardScreen;
